import React, { useState, useRef, useEffect } from "react";
import ButtonSwitcher from "../../../components/ButtonSwitcher";
import BotContent from "./BotContent";
import BotScheduling from "./BotScheduling";
import { tabs } from "../constants/selections";
import { default_chatbot } from "../constants/default";

const AddConciergeModal = ({ selectedDate, onAdd }) => {
  const [isPostable, setIsPostable] = useState(false);
  const [tab, setTab] = useState(tabs[0]);
  const [chatbot, setChatBot] = useState(default_chatbot);
  const dismissElement = useRef();

  useEffect(() => {
    const {data} = chatbot;
    if(data.topic&&data.welcomeText&&data.communicationLayers[0].type)
      setIsPostable(true);
    else
      setIsPostable(false);
  }, [chatbot]);
  const handleClickClose = () => {
    dismissElement.current.click();
  };
  const handleClickCreate = ()=>{
    onAdd(chatbot);
    setChatBot(default_chatbot);
  }
  const handleChangeTab = (tab) => {
    setTab(tab);
  };
  const handleChangeChatBot = (chatbotdata) => {
    chatbot.data = chatbotdata;
    setChatBot({...chatbot});
  };
  const handleChangeTime = (time) => {
    chatbot.time = time;
    setChatBot({...chatbot});
  };
  return (
    <div
      className="modal fade add-concierge-dialog"
      id="add_concierge_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content add-concierge-dialog-content">
          <div className="modal-header">
            <h5 className="modal-title">
              Add a new scheduled concierge interaction
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              ref={dismissElement}
              onClick={handleClickClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1 ">
            <ButtonSwitcher buttonsGroup={tabs} currentTab={tab} onSwitch={handleChangeTab} />

            <BotContent
              onChangeChatBot={handleChangeChatBot}
              isVisible={tab === "Bot Content" ? true : false}
            />

            <BotScheduling
              selectedDate={selectedDate}
              onChangeTime={handleChangeTime}
              isVisible={tab === "Bot Scheduling" ? true : false}
            />
          </div>
          <div className="modal-footer footer-container">
            <div className="btn-action-container">
              {tab === "Bot Content"&&<button
                type="button"
                className="btn btn-orange"
                onClick={()=>setTab("Bot Scheduling")}
              >
                Next
              </button>}
              {tab === "Bot Scheduling"&&<button
                type="button"
                className="btn btn-white"
                onClick={()=>setTab("Bot Content")}
              >
                Back
              </button>}
              {tab === "Bot Scheduling"&&<button
                type="button"
                className="btn btn-green"
                data-dismiss="modal"
                disabled={!isPostable}
                onClick={handleClickCreate}
              >
                Create
              </button>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddConciergeModal;



// WEBPACK FOOTER //
// ./src/screens/AutoConcierge/components/AddConciergeModal.js